import { defineComponent as _defineComponent } from 'vue';
import { trans, transChoice } from 'laravel-vue-i18n';
import { DateTime } from 'luxon';
import Calendar from 'primevue/calendar';
import Dropdown from 'primevue/dropdown';
import MultiSelect from 'primevue/multiselect';
import { ref, watch } from 'vue';
import InputTextarea from '../../Components/InputTextarea.vue';
import OrchardService from '../../Services/OrchardService';
import PlotService from '../../Services/PlotService';
export default /*#__PURE__*/ _defineComponent({
    __name: 'RecordBasicInfo',
    props: {
        plots: {
            type: Array,
        },
        orchardId: {
            type: Number,
        },
        orchardIdVuelidateObject: {
            type: Object,
            required: true,
        },
        plotIds: {
            type: Array,
        },
        plotIdsVuelidateObject: {
            type: Object,
        },
        description: {
            type: String,
            required: false,
        },
        descriptionVuelidateObject: {
            type: Object,
            required: false,
        },
        date: {
            type: Date,
        },
        dateVuelidateObject: {
            type: Object,
            required: true,
        },
    },
    emits: [
        'update:orchardId',
        'update:plotIds',
        'update:description',
        'update:date',
    ],
    setup(__props, { expose, emit }) {
        expose();
        const props = __props;
        const orchardService = new OrchardService();
        const plotService = new PlotService();
        const orchards = ref([]);
        orchardService.getAll().then((options) => (orchards.value = options));
        const plots = ref([]);
        watch(() => props.orchardId, (newVal, oldVal) => {
            if (props.orchardId === undefined) {
                return;
            }
            plotService.getAllByOrchard(props.orchardId).then((options) => {
                plots.value = options;
                let plotIds = props.plotIds;
                if (oldVal !== undefined) {
                    plotIds = [];
                }
                else if (props.plots && props.plots.length > 0) {
                    plotIds = props.plots.map((p) => p.id);
                }
                emit('update:plotIds', plotIds);
            });
        }, {
            immediate: true,
        });
        const __returned__ = { orchardService, plotService, props, emit, orchards, plots, get trans() { return trans; }, get transChoice() { return transChoice; }, get DateTime() { return DateTime; }, get Calendar() { return Calendar; }, get Dropdown() { return Dropdown; }, get MultiSelect() { return MultiSelect; }, InputTextarea };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
